<template>
  <div class="notice-item" :class="[`notice-item--${viewMode}`, isActive ? 'is-active': null, isZoomed ? 'notice-item--zoomed' : null]">
    <a :href="datas.url" class="notice-item-wrapper">
      <div class="color-image-background notice-item-media">
        <div class="notice-item-image" v-if="viewMode === 'line'">
          <img class="notice-item-img" aria-hidden="true" v-if="datas.images && datas.images.medium" :src="datas.images.medium" loading="lazy" :alt="datas.titles.title ? datas.titles.title : datas.title">
          <div class="notice-item-image-empty" v-else>
            <span class="sprite -empty-image">
              <svg viewBox="0 0 1 1" role="img" aria-hidden="true"><use xlink:href="#empty-image"></use></svg>
            </span>
            <p class="color-accent">{{ datas.titles.title ? datas.titles.title : datas.title }}</p>
          </div>
        </div>
        <div class="notice-item-image" v-if="viewMode === 'card'">
          <img class="notice-item-img" aria-hidden="true" v-if="datas.images && datas.images.medium" sizes="(min-width: 768) 50vw, (min-width: 1024px) 33vw, (min-width: 1280px) 25vw, 100vw" loading="lazy" :alt="datas.titles.title ? datas.titles.title : datas.title"
                :srcset="datas.images.large + ' 720w,' + datas.images.medium + ' 360w,' + datas.images.small + ' 190w'">
          <div class="notice-item-image-empty" v-else>
            <span class="sprite -empty-image">
              <svg viewBox="0 0 1 1" role="img" aria-hidden="true"><use xlink:href="#empty-image"></use></svg>
            </span>
            <p class="color-accent">{{ datas.titles.title ? datas.titles.title : datas.title }}</p>
          </div>
        </div>
      </div>
      <div class="notice-item-container">
        <div class="notice-item-content">
          <h2 class="title-lvl-3 notice-item-name" :id="'notice-item-' + datas.id">{{ datas.titles.title ? datas.titles.title : datas.title }}</h2>
          <p class="color-second notice-item-text" v-if="datas.titles.subTitle">{{ datas.titles.subTitle }}</p>
          <p class="color-second notice-item-text" v-if="datas.titles.text">{{ datas.titles.text }}</p>
        </div>
      </div>
    </a>
    <div class="notice-item-actions">
      <button type="button" class="button-light" @click="onPrint" @focus="onFocus" @blur="onBlur" :aria-describedby="'notice-item-' + datas.id">
          <i class="ico ico-print" aria-hidden="true"></i>
          <span class="hide-access">{{ Translator('front.print') }}</span>
      </button>
      <button type="button" class="button-light" @click="onAddToCart" @focus="onFocus" @blur="onBlur" :aria-describedby="'notice-item-' + datas.id">
          <template v-if="inCart">
            <i class="ico ico-trash" aria-hidden="true"></i>
            {{ Translator('front.cart.remove_to_cart') }}
          </template>
          <template v-else>
            <i class="ico ico-cart" aria-hidden="true"></i>
            {{ Translator('front.cart.add_to_cart') }}
          </template>
      </button>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .viewer-element {
    .notice-item {
      margin-left: rem(15);
      margin-right: rem(15);
      &.notice-item--card,
      &.notice-item--line {
        width: calc(100% - #{rem(30)});
      }
      @include tablet {
        &.notice-item--card {
          width: calc(#{percentage(1/2)} - #{rem(30)});
        }
      }
      @include desktop-xl {
        &.notice-item--card {
          width: calc(#{percentage(1/3)} - #{rem(30)});
        }
      }
    }
  }
</style>
<script>
import ConfigService from '@/front/services/config';

export default {
  name: 'Notice',
  props: [
    'datas',
    'viewMode'
  ],
  data: () => ({
    isActive: false,
    inCart: false,
    isZoomed: ConfigService.get('zoomThumbnail')
  }),

  mounted() {
    this.inCart = window.CartService.has( this.datas.id );
  },

  methods: {
    cartUpdated() {
      this.inCart = window.CartService.has( this.datas.id );
    },

    onAddToCart() {
      window.CartService.toggle( this.datas.id );
    },

    onPrint() {
      window.CartService.print([this.datas.id]);
    },

    onFocus() {
      setTimeout(() => {
        this.isActive = true;
      });
    },

    onBlur() {
      this.isActive = false;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
}
</script>